
import React from "react";
import ShoppingPng3 from "../../assets/Woman_Shopping.png";

const LoginImage = () => (
  <div className="hidden md:flex justify-end items-start col-span-2">
    <img src={ShoppingPng3} className="max-w-md lg:max-w-xl" alt="Shopping" />
  </div>
);

export default LoginImage;

